export class HttpModel {
  partialURL: string;
  dataJSON: any;
  dataType: string;
  callType: string;
  responseType: any;
  queryParams: any;

  constructor(
    partialURL: string = '',
    dataJSON: any = [],
    queryParams: any = null,
    callType: string = 'GET',
    responseType: any = 'json',
    dataType: string = 'json'
  ) {
    this.partialURL = partialURL;
    this.dataJSON = dataJSON;
    this.queryParams = queryParams;
    this.dataType = dataType;
    this.callType = callType;
    this.responseType = responseType;
  }
}
